import { EditStudentProfile } from './EditStudentProfile';

export default EditStudentProfile;
